import { Injectable } from '@angular/core';
import { calcModalWidth } from 'app/utilities/modal.utils';
import { debounceTime, fromEvent, map, publishReplay, refCount, shareReplay, startWith } from 'rxjs';

export const MOBILE_WIDTH_LIMIT = 768;

@Injectable({
  providedIn: 'root'
})
export class ModalService {
 
  public readonly isScreenMobile$ = fromEvent(window, 'resize').pipe(
    debounceTime(1000),
    startWith(null),
    map(() => this.isScreenWidthMobileEnabled()),
    shareReplay({ refCount: true, bufferSize: 1 })
  );
  
  private _isScreenMobile = false;
  constructor() { }

  getAppropriateWidthProperty(initialWidth?: number): string {
    return this.isScreenMobile ? '100vw' : calcModalWidth(initialWidth || 550);
  }
  get isScreenMobile() {
    return this._isScreenMobile;
  }
  private isScreenWidthMobileEnabled() {
    const newWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return newWidth <= MOBILE_WIDTH_LIMIT;
  }
  getAppropriateMaxWidthProperty() {
    return this.isScreenMobile ? '100vw' : '80vw';
  }
  getAppropriateHeightProperty(): string {
    return this.isScreenMobile ? '100vh' : 'auto';
  }

  getAppropriateMaxHeightProperty() {
    return this.isScreenMobile ? '100vh' : '80vh';
  }
}
